<template>
    <div>
        <div id="top" class="h66">
            <div class="pa20 l">
                <div id="logo" width="98" height="40"></div>
            </div>
            
        </div>
        <div id="register">
            <div class="w750 ft16">
                <h1 class="mt50 f20 cff2104 tal">老用户绑定</h1>
                <ul class="mt20">
                <li  class="mb30 yz">
                    <div class="l w100 h36 tar">门牌号：</div>
                    <div class="l h36"><input  class="h36 w340 plr15 f14 tal  br2" v-model="account" type="text" placeholder="请输入门牌号"/></div>
                    <div class="l f14 ml10 h36"> <span class="cf06000"> * </span></div>
                    <div class="l f14 ml10 h36"> </div>
                </li>
                    <li  class="mb30 yz">
                    <div class="l w100 h36 tar">密码：</div>
                    <div class="l h36"><input  class="h36 w340 plr15 f14 tal  br2" v-model="password" type="password" placeholder="请输入密码"  maxlength="16"/></div>
                    <div class="l f14 ml10 h36"> <span class="cf06000"> * </span></div>
                    <div class="l f14 ml10 h36"> <label id="password1_tishi">密码长度为6-12位的数字和字母</label></div>
                </li> 
                <li  class="mb30 yz">
                    <div class="l w100 h36 tar">验证码：</div>
                    <div class="l h36"><input  class="h36 w248 plr15 f14 tal  br2" v-model="loginCode" type="text" placeholder="请输验证码" /></div>
                    <div class="l ml10 f14 h36">
                        <div class="code" @click="refreshCode">
                            <s-identify :identifyCode="identifyCode"></s-identify>
                        </div>
                    </div>
                </li>
                <li  class=" yz">
                    <div class="l w100 h36 tar"></div>
                    <div class="l h36"><input class="fx1" v-model="boxcheck"  type="checkbox"/></div>
                    <div class="l f14 h36">我已阅读并同意<a href="http://www.yanzhengma.cn/user_2office" target="_bank">《云验证平台协议》</a></div>
                </li>
                    <li  class="mb30 yz">
                    <div class="l w100 h36 tar"></div>
                    <div class="l h36"> <button id="regBtn" class="h36 w280  plr15 f18 dlan" @click="binduser" style="cursor:pointer;">立即绑定</button></div>
                </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import '../../assets/css/index.css'; /*引入公共样式*/
 import {is_email,isMobil, is_number} from '../../assets/js/checkFunction.js'
import {setCookie,getCookie} from '../../assets/js/cookie.js'
export default {
    components : {
        
    },
    data() {
        return {
            identifyCodes: "1234567890",
            identifyCode: "",
            account:'',
            password:'',
            loginCode:'',
            loginId:'',
            orgId:'',
            mobileString:'',
            memberIdstr:'',
            boxcheck:false
        };
    },
    mounted() {
        this.identifyCode = "";
        this.makeCode(this.identifyCodes, 4);
        this.loginId = this.$route.params.loginId == undefined ? "" : this.$route.params.loginId;
        this.orgId = this.$route.params.orgId == undefined ? "" : this.$route.params.orgId;
        this.mobileString = this.$route.params.mobileString == undefined ? "" : this.$route.params.mobileString;
        this.memberIdstr = this.$route.params.memberIdstr == undefined ? "" : this.$route.params.memberIdstr;
        //console.log(this.loginId + ":" +this.orgId + ":" + this.mobileString + ":" + this.memberIdstr);
    },
    methods: {
        closediv() {
            this.isShow = false;
        },
        sureBtn() {
            this.$router.push('/')
        },
        refreshCode() {
            this.identifyCode = "";
            this.makeCode(this.identifyCodes, 4);
        },
        makeCode(o, l) {
            for (let i = 0; i < l; i++) {
                this.identifyCode += this.identifyCodes[
                this.randomNum(0, this.identifyCodes.length)
                ];
            }
        },
        randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },
        binduser() {
            var that = this;
            if(this.account.trim() == ''){
                alert("请输入门牌号")
                return
            }
            if(this.password.trim() == ''){
                alert("请输入密码")
                return
            }
            if(this.loginCode == ""){
                alert("请输入验证码")
                return
            }
            if(this.loginCode != this.identifyCode){
                alert("验证码不正确")
                return
            }
            if(this.boxcheck == false){
                alert("阅读并同意《云验证平台协议》必须选中！");
			    return;
            }
            let data = {'account':this.account.trim(),"password":this.password.trim(),"loginId":this.loginId,"orgId":this.orgId,"mobileString":this.mobileString,"memberIdstr":this.memberIdstr}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/alicrm/alicrmbind.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            }).then(function(res) {
                if('0000000' == res.data.code){
                        that.GLOBAL.token = res.data.token
                        setCookie('2officesessionid',res.data.token,60*60*10)
                        localStorage.setItem("orgId", res.data.orgId);
                        localStorage.setItem("loginId",res.data.loginId);
                        localStorage.setItem("mobileString", res.data.mobileString);
                        localStorage.setItem("memberIdstr", res.data.memberIdstr);
                        location.href = '/main';
                    }
                    else{
                        alert(res.data.msg);
                    }
            })
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/alicrm/alicrmbind.vue